import { render, staticRenderFns } from "./split-button-playground.vue?vue&type=template&id=6c315a35&"
import script from "./split-button-playground.vue?vue&type=script&lang=js&"
export * from "./split-button-playground.vue?vue&type=script&lang=js&"
import style0 from "./split-button-playground.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports